
import Panel from 'vux/src/components/panel/index.vue'

import {get,post} from '../api'
export default {
components: {
Panel
},
mounted() {
this.getAutoHeight();
const self=this;
window.onresize=function(){
self.getAutoHeight();
};


this.lxTags=["毛坯","成品"];


this.getXN(this.checkLX);
this.onSearch();
},
watch: {
'searchQuery': {
handler(newValue, oldValue) {



},
deep: true
},
'checkXN': {
handler(newValue, oldValue) {


this.onSearch(1);
},
deep: true
},
'checkLX': {
handler(newValue, oldValue) {


this.checkXN=[];
this.getXN(this.checkLX);
this.onSearch(1);
},
deep: true
}
},
methods: {
onSearch (pageindex){
if(pageindex!==undefined){
this.pageIndex=pageindex;
}








if(this.checkXN.length==0){
this.checkXN=["00"];
}

let searchParameter={title:this.checkXN.join(','),ptype:this.checkLX,content:this.searchQuery,pageindex:this.pageIndex};
console.log('searchParameter',searchParameter);
if(this.checkLX=="成品"){
post('/SearchCenter/QueryCP', searchParameter).then(response => {

if(response.code==1){




this.results= response.data||[];
this.results.forEach(element => {
element.desc=element.content;
});
this.pageCount=response.PageCount;
console.log('data',response);
}
else if(response.code==0){
this.$message({
message: response.data,
type: 'error'
});
}
}).catch(error => {
console.log(error);
});
}
else if(this.checkLX=="毛坯"){
post('/SearchCenter/QueryMP', searchParameter).then(response => {

if(response.code==1){




this.results= response.data||[];
this.results.forEach(element => {
element.desc=element.content;
});
this.pageCount=response.PageCount;
console.log('data',response);
}
else if(response.code==0){
this.$message({
message: response.data,
type: 'error'
});
}
}).catch(error => {
console.log(error);
});
}
},
onPreSearch(){
if(this.pageIndex<=1)return;
this.pageIndex=this.pageIndex-1;
this.onSearch();
},
onNextSearch(){
if(this.pageIndex>=this.pageCount)return;
this.pageIndex=this.pageIndex+1;
this.onSearch();
},
getXN(type){
if(type=="毛坯"){
get('/SearchCenter/QueryMPXN', {}).then(response => {

if(response.code==1){
this.xnTags=response.data;
}
else if(response.code==0){
this.$message({
message: response.data,
type: 'error'
});
}
}).catch(error => {
console.log(error);
});
}
else if(type=="成品"){
get('/SearchCenter/QueryCPXN', {}).then(response => {

if(response.code==1){
this.xnTags=response.data;
}
else if(response.code==0){
this.$message({
message: response.data,
type: 'error'
});
}
}).catch(error => {
console.log(error);
});
}
},
getAutoHeight(){
this.$nextTick(()=>{





var div_results = document.getElementById('search-results');
var screenHeight = window.innerHeight;

div_results.style.height = (100*3) + 'px';
});
},
getStyle(obj,attr){

let result = obj.currentstyle?
obj.currentstyle[attr].replace("px","")
:document.defaultView.getComputedStyle(obj, null)[attr].replace("px","");
return Number(result);
}
},
data () {
return {
searchQuery:'',
results:[],
xnTags:[],
checkXN:[],
lxTags:[],
checkLX:"毛坯",
pageIndex:1,
pageCount:0
}
},
};



// WEBPACK FOOTER //
// ./src/components/WholeSaleCenter/Mobile.vue